
import React, { useState } from "react";
import { Box, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, DialogActions, alpha, Avatar } from "@mui/material";
import ButtonComponent from "src/components/shared/Button";
import theme from "src/config/theme";
import { CardContainer, CardHeader, InnerContainer, ProfileContainer, Title, Year_Gender, Title2, Dot, Line, InnerContainer2, Title3, SymptomsContainer, SymptomsText, CheapContainer, MenuContainer, AvatarIcon, PagingContainer, Container2, InnerAppointments, InnerBox } from "./Style";
import { ReactComponent as Rotate } from '../../../../assets/images/rotate-right.svg';
import { ReactComponent as More } from '../../../../assets/images/more.svg';
import { ReactComponent as Profile } from '../../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/images/arrow-right 2.svg';
import { ReactComponent as SliderVertical } from '../../../../assets/images/slider-vertical.svg';
import { ReactComponent as Edit2 } from '../../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../assets/images/add-square.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/images/close-circle.svg';
import { ReactComponent as Danger } from '../../../../assets/images/danger.svg';
import { ReactComponent as Complete } from '../../../../assets/images/tick-circle.svg';
import useResponsive from "src/components/hooks/useResponsive";
import { useNavigate } from 'react-router-dom';
import Paging from "src/components/App/Paging";
const getStatusStyles = (status) => {
    switch (status) {
        case "Scheduled":
            return {
                background: "rgba(150, 57, 150, 0.12)",
                color: theme.palette.action.purpleDark,
            };
        case "In Queue":
            return {
                background: "rgba(103, 57, 150, 0.14)",
                color: theme.palette.action.purpleLight,
            };
        case "Attending Now":
            return {
                background: "rgba(57, 150, 57, 0.18)",
                color: theme.palette.action.green,
            };
        case "Complete":
            return {
                background: "rgba(57, 150, 57, 0.18)",
                color: theme.palette.action.green,
            };
        case "Cancelled":
            return {
                background: "rgba(150, 57, 57, 0.18)",
                color: theme.palette.action.red,
            };
        case "Treatment Scheduled":
            return {
                background: "rgba(150, 57, 150, 0.12)",
                color: theme.palette.action.purpleDark,
            };
        case "Overdue":
            return {
                background: "rgba(150, 57, 57, 0.18)",
                color: theme.palette.action.red,
            };
        default:
            return {
                background: theme.palette.grey[300],
                color: theme.palette.action.red,
            };
    }
};


const AppointmentCard = ({ data, page, perPage, setPage, totalCount, handleAttendNowAppointment, handleAddToQueue, handleCompleteAppointment, handleCancelAppointment, handleCompleteOpen, handleOpen }) => {
    const { isDesktop, isMobile, isTablet } = useResponsive();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const Width = '20px';
    const Height = '20px';
    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(item);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };


    const getActionsForRow = (selectedRow) => {
        if (!selectedRow) {
            return [];
        }

        const viewProfileAction = {
            label: "View Profile",
            icon: <Profile width={Width} height={Height} />,
            onClick: () => navigate(`/appointment/Patients/${selectedRow.appointmentId}`),
        };

        const bookAgainAction = {
            label: "Book Again",
            icon: <Rotate width={Width} height={Height} />,
            // onClick: () => handleBookAgain(row),
        };

        const baseActions = [
            viewProfileAction,
            { label: "Attend Now", icon: <ArrowRight width={Width} height={Height} />, onClick: () => handleAttendNowAppointment(selectedRow.appointmentId) },
            { label: "Add to Queue", icon: <SliderVertical width={Width} height={Height} />, onClick: () => handleAddToQueue(selectedRow.appointmentId) },
            // { label: "Edit", icon: <Edit />, onClick: () => alert(`Editing ${row.patient}`) },
            { label: "Complete", icon: <Complete width={Width} height={Height} />, onClick: () => handleCompleteOpen(selectedRow.appointmentId, selectedRow.patientData) },
            {
                label: "Cancel",
                icon: <Close width={Width} height={Height} />,
                onClick: () => handleOpen(selectedRow.appointmentId, selectedRow.patientData),
            },
        ];

        const statusLabel = selectedRow.status?.props?.children || selectedRow.status?.props?.label || "";

        if (statusLabel === "In Queue") {
            return baseActions.filter(action => action.label !== "Add to Queue" && action.label !== "Complete");
        }

        if (statusLabel === "Attending Now") {
            return baseActions.filter(action => !["Add to Queue", "Attend Now", "Edit"].includes(action.label));
        }
        if (["Treatment Scheduled", "Scheduled"].includes(statusLabel)) {
            return baseActions.filter(action => action.label !== "Complete");
        }
        if (["Cancelled", "Complete"].includes(statusLabel)) {
            return [viewProfileAction, bookAgainAction];
        }
        return baseActions;
    };
    const actions = getActionsForRow(selectedRow);





    return (

        <Container2>
            <InnerAppointments>
                <InnerBox isEmpty={data.length === 0}>


                    {data.map((item, index) => {
                        const statusLabel = item.status.props.label;
                        const statusStyles = getStatusStyles(statusLabel);
                        return (
                            isMobile || isTablet ? (
                                <CardContainer>
                                    <CardHeader>
                                        <InnerContainer sx={{ flex: 1 }}>
                                            <Title sx={{ 
                                                fontWeight: 600, 
                                                whiteSpace: 'nowrap', 
                                                overflow: 'hidden', 
                                                textOverflow: 'ellipsis' 
                                            }}>
                                                {item.patientData?.fullName || "N/A"}
                                            </Title>
                                            <Year_Gender sx={{ width: 'auto' }}>
                                                <Title2>{item.age}</Title2>
                                                <Dot />
                                                <Title2>{item.sex}</Title2>
                                            </Year_Gender>
                                        </InnerContainer>
                                        <InnerContainer2>
                                            <CheapContainer
                                                label={statusLabel}
                                                sx={{
                                                    background: statusStyles.background,
                                                    color: statusStyles.color,
                                                    borderRadius: "100px",
                                                    padding: "6px 12px",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    ...(isMobile || isTablet ? theme.mobileTypography.h6 : {}),

                                                }}
                                            />

                                        </InnerContainer2>
                                    </CardHeader>
                                    <Line />
                                    <CardHeader>
                                        <InnerContainer>
                                            <SymptomsText>{item.symptoms}</SymptomsText>
                                            <Year_Gender>
                                                <Title2>Symptoms</Title2>
                                            </Year_Gender>
                                        </InnerContainer>
                                    </CardHeader>
                                    <CardHeader>
                                        <InnerContainer>
                                            <SymptomsText>{item.date.split(", ")[0]} {item.date.split(", ")[1]}</SymptomsText>
                                            <Year_Gender>

                                                <Title2>Date & Time</Title2>
                                            </Year_Gender>
                                        </InnerContainer>
                                        <MenuContainer
                                            onClick={(event) => handleMenuOpen(event, item)}
                                            isActive={selectedRow === item}

                                        >
                                            <More />
                                        </MenuContainer>
                                    </CardHeader>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                        sx={{
                                            "& .MuiPaper-root": {
                                                width: "151px",
                                                borderRadius: "12px",
                                                padding: "4px 10px",
                                                backgroundColor: "red",
                                                border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                                backgroundColor: theme.palette.gery.white,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                gap: '5px',

                                            }
                                        }}
                                    >
                                        {actions.map((action, index) => (
                                            <MenuItem key={index} onClick={() => {
                                                action.onClick(selectedRow);
                                                handleMenuClose();
                                            }} >
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    {action.icon} <Typography sx={{ ...theme.mobileTypography.body2, }}>{action.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </CardContainer>
                            ) : (
                                <CardContainer key={index}>
                                    <CardHeader sx={{ width: '100%', gap: '16px' }}>
                                        <ProfileContainer sx={{ background: theme.palette.primary.light4 }}>
                                            <Avatar 
                                                sx={{ 
                                                    width: '100%', 
                                                    height: '100%', 
                                                    borderRadius: '8px', 
                                                    background: 'transparent',
                                                    color: theme.palette.primary.main,
                                                    fontSize: '18px',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {item.patientData?.fullName?.charAt(0).toUpperCase() || "P"}
                                            </Avatar>
                                        </ProfileContainer>
                                        <InnerContainer>
                                            <Title sx={{ 
                                                whiteSpace: 'nowrap', 
                                                overflow: 'hidden', 
                                                textOverflow: 'ellipsis',
                                                display: 'block',
                                                pr: 1
                                            }}>
                                                {item.patientData?.fullName || "N/A"}
                                            </Title>
                                            <Year_Gender>
                                                <Title2 sx={{ whiteSpace: 'nowrap' }}>{item.age}</Title2>
                                                <Dot />
                                                <Title2>{item.sex}</Title2>
                                            </Year_Gender>
                                        </InnerContainer>
                                    </CardHeader>
                                    <Line />
                                    
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', py: 1 }}>
                                        <InnerContainer2>
                                            <Title3 sx={{ fontSize: '14px' }}>Contact No.</Title3>
                                            <Title sx={{ fontSize: '15px', fontWeight: 500 }}>{item.contact || "N/A"}</Title>
                                        </InnerContainer2>
                                        <InnerContainer2>
                                            <Title3 sx={{ fontSize: '14px' }}>Time</Title3>
                                            <Title sx={{ fontSize: '15px', fontWeight: 600 }}>{item.date.split(", ")[1]}</Title>
                                        </InnerContainer2>
                                        <InnerContainer2>
                                            <Title3 sx={{ fontSize: '14px' }}>Date</Title3>
                                            <Title sx={{ fontSize: '15px', fontWeight: 600 }}>{item.date.split(", ")[0]}</Title>
                                        </InnerContainer2>
                                    </Box>

                                    <SymptomsContainer sx={{ 
                                        height: '90px', 
                                        m: '0 12px', 
                                        p: 1.5, 
                                        alignItems: 'flex-start',
                                        justifyContent: 'flex-start',
                                        overflowY: 'auto'
                                    }}>
                                        <SymptomsText sx={{ fontSize: '13px', textAlign: 'left', lineHeight: 1.4 }}>
                                            {item.symptoms || "No symptoms recorded"}
                                        </SymptomsText>
                                    </SymptomsContainer>
                                    
                                    <Line />
                                    <InnerContainer2 sx={{ py: 1 }}>
                                        <CheapContainer
                                            label={statusLabel}
                                            sx={{
                                                background: statusStyles.background,
                                                color: statusStyles.color,
                                                borderRadius: "100px",
                                                padding: "6px 12px",
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                height: '28px'
                                            }}
                                        />
                                        <MenuContainer
                                            onClick={(event) => handleMenuOpen(event, item)}
                                            isActive={selectedRow === item}
                                            sx={{ width: '32px', height: '32px' }}
                                        >
                                            <More width="18px" height="18px" />
                                        </MenuContainer>
                                    </InnerContainer2>

                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                        PaperProps={{
                                            sx: {
                                                width: "176px",
                                                borderRadius: "12px",
                                                mt: 1,
                                                boxShadow: theme.shadows[4],
                                                border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                            }
                                        }}
                                    >
                                        {actions.map((action, index) => (
                                            <MenuItem 
                                                key={index} 
                                                onClick={() => {
                                                    action.onClick(selectedRow);
                                                    handleMenuClose();
                                                }}
                                                sx={{ py: 1 }}
                                            >
                                                <Box display="flex" alignItems="center" gap={1.5}>
                                                    {action.icon} 
                                                    <Typography sx={{ fontSize: '14px' }}>{action.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </CardContainer>
                            )
                        );
                    })}
                </InnerBox>
                <PagingContainer>
                    <Paging
                        page={page}
                        perPage={perPage}
                        count={totalCount || 0}
                        onChange={(newPage) => setPage(newPage)}
                    />

                </PagingContainer>
            </InnerAppointments>


        </Container2 >
    );
};

export default AppointmentCard;

